import { RefObject } from 'react';

export const scrollToTarget = (targetRef?: RefObject<HTMLDivElement>) => () => {
  const offset = targetRef?.current?.offsetTop || 0;
  window.setTimeout(() => window.scroll(0, offset), 0);
};
